import { useFormContext } from 'react-hook-form'

import { FormError } from '@fortem-monorepo/react-ui'
import { SearchSelect } from '@fortem-monorepo/react-ui'
import { FormField, FormItem, FormLabel } from '@fortem-monorepo/react-ui'

import {
  DISTRIBUTION_POLICY_OPTIONS,
  DistributionPolicy,
} from '@/pages/instruments/new-instrument/constants/distribution-policies'

export interface DistributionPolicyFormFieldProps {}

export const DistributionPolicyFormField: React.FC<DistributionPolicyFormFieldProps> = ({}) => {
  const { control, setValue } = useFormContext<{ distribution_policy: DistributionPolicy }>()

  return (
    <FormField
      name="distribution_policy"
      control={control}
      render={({ field: { value } }) => {
        return (
          <FormItem>
            <div className="flex items-center justify-between gap-2">
              <FormLabel>Distribution Policy</FormLabel>
              <FormError />
            </div>
            <SearchSelect
              value={value}
              setValue={(value) =>
                setValue('distribution_policy', value as DistributionPolicy, {
                  shouldValidate: true,
                })
              }
              className={'min-w-auto'}
              placeholder={'Select a distribution policy'}
              options={DISTRIBUTION_POLICY_OPTIONS}
            />
          </FormItem>
        )
      }}
    />
  )
}
